import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import PeerChat from '../../pages/PeerChat'

import QueueStateProvider from '../../providers/QueueStateProvider'
import AddRemoveParticipantProvider from '../../providers/AddRemoveParticipantProvider'
import OwnerProvider from '../../providers/OwnerProvider'
import ChatEditStateProvider from '../../providers/ChatEditStateProvider'

const PeerChatsRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route
        path={path}
        render={props => (
          <QueueStateProvider isPeerChat>
            <ChatEditStateProvider>
              <AddRemoveParticipantProvider>
                <OwnerProvider>
                  <PeerChat />
                </OwnerProvider>
              </AddRemoveParticipantProvider>
            </ChatEditStateProvider>
          </QueueStateProvider>
        )}
      />
    </Switch>
  )
}

export default PeerChatsRoute
